/**
 * Cómo pintar answers[] de P4 (payload_json o filas user_support_answers).
 */
export const listSupportAnswers = (support) => {
  if (!support) return [];
  const payload = support.payload_json && Array.isArray(support.payload_json.answers)
    ? support.payload_json.answers
    : [];
  if (payload.length) return payload;
  return Array.isArray(support.answers) ? support.answers : [];
};

export const formatSupportAnswerValue = (answer) => {
  if (!answer) return '—';
  if (answer.value_label) return answer.value_label;
  if (Array.isArray(answer.value)) return answer.value.join(', ') || '—';
  const raw = answer.value != null ? answer.value : answer.answer_value;
  if (raw == null || String(raw).trim() === '') return '—';
  return String(raw);
};

export const formatSupportAnswerLabel = (answer) => {
  return answer.label || answer.question_key || answer.key || '—';
};
